(() => {
  class DeferredReveal extends HTMLElement {
    constructor() {
      super();
      this.onWindowLoad = this.onWindowLoad.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
    }

    connectedCallback() {
      this.classList.remove('is-initialized');

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        this.reveal();
        return;
      }

      if (document.readyState === 'complete') {
        this.reveal();
        return;
      }

      window.addEventListener('load', this.onWindowLoad, { once: true });
    }

    disconnectedCallback() {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }

      window.removeEventListener('load', this.onWindowLoad);
    }

    onWindowLoad() {
      this.reveal();
    }

    onSectionLoad(event) {
      if (!event.target.contains(this)) return;
      this.classList.remove('is-initialized');
      this.reveal();
    }

    reveal() {
      requestAnimationFrame(() => {
        this.classList.add('is-initialized');
      });
    }
  }

  const definitions = [
    ['deferred-reveal', class DeferredRevealElement extends DeferredReveal {}],
    ['lp-fps-grid', class LpFpsGrid extends DeferredReveal {}],
    // ['bps-card', class BpsCard extends DeferredReveal {}],
  ];

  definitions.forEach(([tagName, ElementClass]) => {
    if (customElements.get(tagName)) return;
    customElements.define(tagName, ElementClass);
  });
})();
